import * as React from 'react';
import { useSelector } from 'react-redux';
import { ContactsBlock } from '../../../components/TermsInfo';
import { selectIsCallbackAvailable, selectPhone } from '../../../selectors/newbuilding';
import { CallbackButtonContainer } from '../../CallbackButton';
import { PhoneButtonDesktopContainer } from '../../PhoneButton';

export const ContactsBlockContainer: React.FC = () => {
  const isCallbackAvailable = useSelector(selectIsCallbackAvailable);
  const phone = useSelector(selectPhone);

  const callbackButton = isCallbackAvailable ? <CallbackButtonContainer /> : null;
  const phoneButton = phone ? <PhoneButtonDesktopContainer /> : null;

  if (!callbackButton && !phoneButton) {
    return null;
  }

  return <ContactsBlock callbackButton={callbackButton} phoneButton={phoneButton} />;
};
